import post from '@/api/post/'
import get from '@/api/get/'

export default {
  getGeoZone (link) {
    return get(link, true)
  },
  getGeoZones () {
    return post('get_geo_zones').then(response => response.data.zones)
  }
}



// WEBPACK FOOTER //
// ./src/api/services/objects/zones/index.js